import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"
}), 'PlayArrowOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayArrowOutlined.js
// module id = 5498
// module chunks = 2